import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { CutOffDateReached } from '../result/cut-off-date-reached';
import { IPickPreCheckError, PreCheckErrorMixin } from './pre-check-error';

export class CutoffDatePreCheckError extends PreCheckErrorMixin(CutOffDateReached) implements IPickPreCheckError {
    constructor(pickId: string, date: Date) {
        super(pickId, date);
        this.type = PlacementErrorType.CutOffDateReached;
    }

    readonly date: Date;
}
